import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
class ExportTranscript {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly interviewId: number,
		public readonly includeSpeakers: boolean,
		public readonly includeTimestamps: boolean,
	) {
		Object.freeze(this);
	}

	toQueryString(): string {
		const queryParams = new URLSearchParams({
			includeSpeakers: String(this.includeSpeakers),
			includeTimestamps: String(this.includeTimestamps),
		});

		return queryParams.toString();
	}
}

export default ExportTranscript;
